import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import {
  DestinationSearchResponse,
  Location,
} from '../components/bids-and-offers/lot-new/create-lot.model';

@Injectable({
  providedIn: 'root',
})
export class DestinationSearchService extends Query<DestinationSearchResponse> {
  document = gql`
    query SearchLocations($input: String!) {
      searchLocations(query: $input) {
        name
        display_name
        importance
        addresstype
      }
    }
  `;
}
